import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const pinterest: Platform = {
  id: 'pinterest',
  name: 'Pinterest',
  iconIndex: PlatformRegistry.pinterest.index,
  color: PlatformRegistry.pinterest.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.pinterest.com/pin/create/button/', {
      url: content.url,
      media: content.image,
      description: content.title || content.description,
    });
  },
};

